import React from "react";
import useGetUsers from "../../../hooks/masters/users/useGetUsers";
import Spinner from "../../../components/spinner";
import Errors from "../../errors";
import { RiPencilFill } from "react-icons/ri";
import { IoTrashBin } from "react-icons/io5";
import { convertToSentenceCase } from "../../../utilities";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";
import useDeleteUsers from "../../../hooks/masters/users/useDeleteUsers";
import ConfirmationModal from "../../../components/elements/ConfirmationModal";

const UsersListing = () => {
  const {
    userList,
    status,
    isUserListLoading,
    error,
    handleSearch,
    searchQuery,
  } = useGetUsers();

  const { toggleConfirmation, showConfirmation, deleteUser } = useDeleteUsers();

  return (
    <div className="category px-4">
      <div className="category__head headingBorder__b">
        <h2 className="titleHeading">Users</h2>
      </div>

      {showConfirmation && (
        <ConfirmationModal
          open={showConfirmation}
          handleClose={toggleConfirmation}
          title="Delete User?"
          message="Are you sure you want to delete this user? This action cannot be undone."
          onConfirm={deleteUser}
          confirmText="Delete"
          cancelText="Cancel"
        />
      )}

      <div className="flex items-end space-x-4 my-5">
        <div className="flex-1">
          <input
            onChange={(e) => handleSearch(e.target.value)}
            value={searchQuery}
            type="text"
            placeholder="Search By Key Word...."
            className="input"
          />
        </div>
        <Link to={`add-user`} className="block">
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            className="primaryBtn-outlined"
          >
            Add user
          </Button>
        </Link>
      </div>

      {isUserListLoading ? (
        <Spinner />
      ) : status === "error" ? (
        <Errors errorObject={error} inline />
      ) : (
        <div className="overflow-x-auto bg-white rounded-lg shadow overflow-y-auto relative">
          <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
            <thead>
              <tr className="text-left">
                <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                  ID
                </th>
                <td className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                  <p className="w-44">Name</p>
                </td>
                <td className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                  Email
                </td>
                <td className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                  <p className="w-24">Phone</p>
                </td>
                <td className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                  Role
                </td>
                <td className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                  Actions
                </td>
              </tr>
            </thead>
            <tbody>
              {userList.map((user) => (
                <tr key={user.id} className="border-b">
                  <td className="px-4 py-2">{user.user_id}</td>
                  <td className="px-4 py-2">{user.name}</td>
                  <td className="px-4 py-2">{user.email}</td>
                  <td className="px-4 py-2">{user.phone}</td>
                  <td className="px-4 py-2">
                    {convertToSentenceCase(user.user_role)}
                  </td>
                  <td className="px-4 py-2">
                    {/* Actions can be added here */}
                    <Link
                      to={`/masters/users/edit-user/${user.user_id}`}
                      className="text-blue-500 hover:underline"
                    >
                      <RiPencilFill className="inline-block mr-1 w-5 h-5" />
                    </Link>
                    <button
                      className="text-red-500 hover:underline ml-2"
                      onClick={() => toggleConfirmation(user.user_id)}
                    >
                      <IoTrashBin className="inline-block w-5 h-5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UsersListing;
